export default {
  'media.title': 'Media &',
  'media.titleHighlight': 'Links',
  'media.subtitle': 'Research outcomes, projects, and media links',
  'media.projectsTitle': 'Projects & Media',
  'media.socialTitle': 'Social Media',
  'media.showMore': 'Show More ({count} more items)',
  'media.cta.title': 'Collaboration Opportunities',
  'media.cta.description': 'I actively pursue collaborative research and development with various people, regardless of university or industry boundaries. Please feel free to reach out.',
  'media.cta.button': 'Contact Me',

  // Social Media
  'media.social.linkedin.desc': 'Professional networking',
  'media.social.twitter.desc': 'Information sharing on research and technology',
  'media.social.email.desc': 'Direct inquiries',
};
